import {
  ActionButton,
  Loader,
  LocalizedString,
} from "@dbn/omnichannel-design-system-g4p";
import { lazy, Suspense } from "react";

const PdfViewerInternal = lazy(() =>
  import("./PdfViewerInternal").then(module => ({
    default: module.PdfViewerInternal,
  }))
);

type DataProps =
  | {
      data?: never;
      dataUrl: string;
    }
  | {
      data: string;
      dataUrl?: never;
    };

export type PdfViewerProps = {
  onLastPageReach?: Function;
  onPdfLoaded?: (numPages?: number) => unknown;
  onPdfError?: (exception?: string) => unknown;
  workerSrc?: string;
  pdfAltText?: string;
  showScrollButtons?: boolean;
  actions?: [] | [ActionButton] | [ActionButton, ActionButton];
  ariaLabelScrollUp?: LocalizedString;
  ariaLabelScrollDown?: LocalizedString;
  minHeight?: string;
} & DataProps;

export const PdfViewer = (props: PdfViewerProps) => (
  <Suspense fallback={<Loader />}>
    <PdfViewerInternal {...props} />
  </Suspense>
);
